import { Box, withStyles } from '@material-ui/core';

export const TabContentWrapper = withStyles(({ spacing }) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2)
  }
}))(Box);
